import useCrud from 'hooks/useCrud';
import { seat } from 'services/api/assistant.account';

function useSeat() {
  return useCrud({
    read: seat,
  });
}

export default useSeat;
